{
	"actions": {
		"bulk_revoke": "Revoke all by this creator",
		"cancel": "Cancel",
		"open_menu": "Open actions",
		"revoke": "Revoke"
	},
	"bulk_revoke": {
		"confirm": "Revoke all",
		"description": "Every active link this person created stops working immediately. This cannot be undone.",
		"done_one": "Revoked {{count}} link.",
		"done_other": "Revoked {{count}} links.",
		"none": "This person has no active links.",
		"pending": "Revoking…",
		"title": "Revoke every link created by {{name}}?"
	},
	"columns": {
		"access_count": "Opens",
		"creator": "Created by",
		"expiry": "Expires",
		"kind": "Type",
		"password": "Password",
		"resource": "Resource",
		"state": "State"
	},
	"creator": {
		"unknown": "Removed member"
	},
	"empty": {
		"description": "No member of your organization has created a public link yet.",
		"disabled_description": "Public links are turned off for this organization. Enable them in Policies to let members create one.",
		"disabled_title": "Links are disabled",
		"no_matches_description": "Try a different filter.",
		"no_matches_title": "No links match these filters",
		"title": "No active links"
	},
	"filters": {
		"creator": "Creator",
		"creator_placeholder": "Search by name or email",
		"expires_within_days": "Expiring within",
		"expires_within_days_option_one": "{{count}} day",
		"expires_within_days_option_other": "{{count}} days",
		"has_password": "Password",
		"state": "State"
	},
	"kind": {
		"download": "Share",
		"upload": "Upload link"
	},
	"kind_filter": {
		"all": "All",
		"download": "Shares",
		"upload": "Upload links"
	},
	"page_title": "Active links",
	"password": {
		"no": "No password",
		"yes": "Password protected"
	},
	"refusal": {
		"not_found": "This link no longer exists. Refresh the list."
	},
	"revoke": {
		"confirm": "Revoke",
		"description": "The link stops working immediately. This cannot be undone.",
		"done": "Link revoked.",
		"pending": "Revoking…",
		"title": "Revoke the link on \"{{name}}\"?"
	},
	"state": {
		"active": "Active",
		"expired": "Expired",
		"policy_blocked": "Blocked by policy",
		"revoked": "Revoked"
	},
	"state_helper": {
		"policy_blocked": "Resumes automatically if the organization's policy allows links again."
	},
	"view": {
		"all": "All",
		"expired": "Expired",
		"live": "Active",
		"revoked": "Revoked"
	}
}
